import { normalizeSpecialistRoleKey } from './activeSpecialistRoleHelper';
import { isFlowEngineGloballyEnabled } from './flowEngineConfigHelper';

/**
 * Alimentador con motor activo envía stage=term (hoja `term`).
 * Pre-Gestor envía stage=pre (hoja `pre`).
 * Gestor y el resto envían full (hoja `datos`).
 */
export const resolveImportStageFromState = (state) => {
  const selected = state?.userRole?.roleLogin?.roleSpecialistSelected;
  const roleKey = selected?.roleKey || normalizeSpecialistRoleKey(selected);
  if (roleKey === 'feeder' && isFlowEngineGloballyEnabled(state?.configuration)) {
    return 'term';
  }
  return roleKey === 'pre-manager' ? 'pre' : 'full';
};
